var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OtherPriceHover',{attrs:{"multi":"","text":_vm.supplier.name,"original":_vm.productList}})
}
var staticRenderFns = []

export { render, staticRenderFns }